import i18n from "@/i18n";

const routes = {
  path: "/manager",
  name: "Manager",
  component: () =>
    import(/* webpackChunkName: "manager" */ "@/views/management/manager/Main"),
  children: [
    {
      path: "list",
      alias: "",
      name: "ManagerList",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/manager/List"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.admin_list"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.admin_list")],
        menu_num: 7,
        sub_menu_num: 71,
        location: "/manager/list",
      },
    },
    {
      path: "write",
      name: "Adminwrite",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/manager/Write"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.admin_write"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.admin_list")],
        menu_num: 7,
        sub_menu_num: 71,
        location: "/manager/list",
      },
    },
    {
      path: "edit/:adminno+",
      name: "Adminedit",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/manager/Write"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.admin_edit"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.admin_list")],
        menu_num: 7,
        sub_menu_num: 71,
        location: "/manager/list",
      },
    },
    {
      path: "timezonelist",
      alias: "",
      name: "TimezoneList",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/timezone/List"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.timezonelist"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.timezonelist")],
        menu_num: 7,
        sub_menu_num: 73,
        location: "/manager/timezonelist",
      },
    },
    {
      path: "timezonewrite",
      name: "TimezoneWrite",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/timezone/Write"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.timezonewrite"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.timezonelist")],
        menu_num: 7,
        sub_menu_num: 73,
        location: "/manager/timezonelist",
      },
    },
    {
      path: "timezoneedit/:timezone_pk+",
      name: "TimezoneEdit",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/timezone/Write"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.timezoneedit"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.timezonelist")],
        menu_num: 7,
        sub_menu_num: 73,
        location: "/manager/timezonelist",
      },
    },
    {
      path: "savingtimelist",
      name: "SavingtimeList",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/savingtime/List"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.savingtimelist"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.savingtimelist")],
        menu_num: 7,
        sub_menu_num: 74,
        location: "/manager/savingtimelist",
      },
    },
    {
      path: "savingtimewrite",
      name: "SavingtimeWrite",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/savingtime/Write"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.savingtimewrite"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.savingtimelist")],
        menu_num: 7,
        sub_menu_num: 74,
        location: "/manager/savingtimelist",
      },
    },
    {
      path: "savingtimeedit/:timezonedst_pk+",
      name: "savingtimeEdit",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/savingtime/Write"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.savingtimeedit"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.savingtimelist")],
        menu_num: 7,
        sub_menu_num: 74,
        location: "/manager/savingtimelist",
      },
    },
    {
      path: "badgelist",
      alias: "",
      name: "BadgeList",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/badge/List"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.badge"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.badge")],
        menu_num: 7,
        sub_menu_num: 77,
        location: "/manager/badgelist",
      },
    },
    {
      path: "badgewrite",
      name: "BadgeWrite",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/badge/Write"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.badge_write"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.badge")],
        menu_num: 7,
        sub_menu_num: 77,
        location: "/manager/badgelist",
      },
    },
    {
      path: "badgeedit/:badge_pk+",
      name: "BadgeEdit",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/badge/Write"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.badge_edit"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.badge")],
        menu_num: 7,
        sub_menu_num: 77,
        location: "/manager/badgelist",
      },
    },
    {
      path: "xpointlist",
      alias: "",
      name: "XpointList",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/xpoint/List"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.x_point_rule"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.x_point_rule")],
        menu_num: 7,
        sub_menu_num: 78,
        location: "/manager/xpointlist",
      },
    },
    {
      path: "xpointwrite",
      name: "XpointWrite",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/xpoint/Write"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.x_point_rule_write"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.x_point_rule")],
        menu_num: 7,
        sub_menu_num: 78,
        location: "/manager/xpointlist",
      },
    },
    {
      path: "xpointedit/:xpoint_pk+",
      name: "XpointEdit",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/management/xpoint/Write"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.x_point_rule_edit"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.x_point_rule")],
        menu_num: 7,
        sub_menu_num: 78,
        location: "/manager/xpointlist",
      },
    },
  ],
};

export default routes;
